export default __webpack_public_path__ + "0f117683911f03c549f94064c330f824.svg";